// Gezond op gewicht (0068_kompas). Handgeschreven zoals photoFrame.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/kompas.ts); openapi.contract.test.ts bewaakt elke aanroep. De vormen
// zijn een spiegel van @amumin/domain (schemas/kompas.ts).
const enc = (v) => encodeURIComponent(v);
/** ?a=1&b=2 (de contracttest haalt `${query(...)}` uit het pad). */
function query(params) {
    return `?${Object.entries(params)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&')}`;
}
export function createKompasClient(t) {
    return {
        state: () => t.request('GET', '/v1/app/kompas'),
        consent: (purpose, textVersion, locale) => t.request('POST', '/v1/app/kompas/consent', {
            purpose,
            accepted: true,
            text_version: textVersion,
            locale,
        }),
        withdraw: (purpose) => t.request('DELETE', `/v1/app/kompas/consent/${enc(purpose)}`),
        saveProfile: (input) => t.request('PUT', '/v1/app/kompas/profile', input),
        prefs: (input) => t.request('PATCH', '/v1/app/kompas/prefs', input),
        day: (date) => t.request('GET', `/v1/app/kompas/days/${enc(date)}`),
        setDay: (date, input) => t.request('PUT', `/v1/app/kompas/days/${enc(date)}`, input),
        overview: (from, to) => t.request('GET', `/v1/app/kompas/overview${query({ from, to })}`),
        setWeight: (date, input) => t.request('PUT', `/v1/app/kompas/weights/${enc(date)}`, input),
        removeWeight: (date) => t.request('DELETE', `/v1/app/kompas/weights/${enc(date)}`),
        /** 0073: lichaamssamenstelling. */
        body: (before) => t.request('GET', `/v1/app/kompas/body${before ? query({ before }) : ''}`),
        setBody: (date, input) => t.request('PUT', `/v1/app/kompas/body/${enc(date)}`, input),
        importBody: (input) => t.request('POST', '/v1/app/kompas/body/import', input),
        /** De metingen van de keuze (in de body, nooit in de URL), voor downloaden, afdrukken en delen. */
        report: (selection) => t.request('POST', '/v1/app/kompas/report', selection),
        /**
         * Het rapport mailen: zonder `to` naar je eigen bevestigde adres; met een ander adres is
         * `confirm_external` verplicht en vraagt de server een verse wachtwoordbevestiging (step-up).
         */
        mailReport: (input) => t.request('POST', '/v1/app/kompas/report/mail', input),
        addFood: (input) => t.request('POST', '/v1/app/kompas/food', input),
        updateFood: (id, input) => t.request('PATCH', `/v1/app/kompas/food/${enc(id)}`, input),
        removeFood: (id) => t.request('DELETE', `/v1/app/kompas/food/${enc(id)}`),
        copyDay: (from, to, meal = null) => t.request('POST', '/v1/app/kompas/food/copy', {
            from,
            to,
            meal,
        }),
        recent: () => t.request('GET', '/v1/app/kompas/recent'),
        /** 0071: mijn maaltijden. */
        meals: () => t.request('GET', '/v1/app/kompas/meals'),
        addMeal: (input) => t.request('POST', '/v1/app/kompas/meals', input),
        updateMeal: (id, input) => t.request('PATCH', `/v1/app/kompas/meals/${enc(id)}`, input),
        removeMeal: (id) => t.request('DELETE', `/v1/app/kompas/meals/${enc(id)}`),
        logMeal: (id, input) => t.request('POST', `/v1/app/kompas/meals/${enc(id)}/log`, input),
        /** Foto van je bord laten schatten (alleen met de toestemming; de foto wordt niet bewaard). */
        photo: (input) => t.request('POST', '/v1/app/kompas/photo', input),
        photoUrl: (id) => `${t.baseUrl}/v1/app/kompas/food/${enc(id)}/photo`,
        tiles: () => t.request('GET', '/v1/app/kompas/tiles'),
        // 0077: een tegel aanzetten kan niet meer (privé op de muur vervangt hem); lezen en weghalen wel.
        removeTile: (householdId) => t.request('DELETE', `/v1/app/kompas/tiles/${enc(householdId)}`),
        exportUrl: () => `${t.baseUrl}/v1/app/kompas/export`,
    };
}
//# sourceMappingURL=kompas.js.map